<div *ngIf="data" class="widget-container">
  <div class="header">
    {{ data.title }}
  </div>
  <div class="loading-content" *ngIf="!info || info.length == 0 || !info[0].values">
    <lib-loading></lib-loading>
  </div>
  <div *ngIf="info && info.length > 0 && info[0].values" class="outdated-facs-container">
    <div class="outdated-facs-content" (click)="iconAction()">
      <svg style="width:48px;height:48px" viewBox="0 0 24 24">
        <path fill="#b72d24" d="M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H9.18C9.6,1.84 10.7,1 12,1C13.3,1 14.4,1.84 14.82,3H19M12,3A1,1 0 0,0 11,4A1,1 0 0,0 12,5A1,1 0 0,0 13,4A1,1 0 0,0 12,3M7,7V5H5V19H19V5H17V7H7M11,9H13V13.5H11V9M11,15H13V17H11V15Z" />
      </svg>
      <span class="outdated-facs-counter">{{ (info[0].values.total < 10 && info[0].values.total != 0) ? '0' : '' }}{{ info[0].values.total }}</span>
    </div>
  </div>
</div>
